import { render, staticRenderFns } from "./SubDisposition.vue?vue&type=template&id=2cbf0a73&"
import script from "./SubDisposition.vue?vue&type=script&lang=js&"
export * from "./SubDisposition.vue?vue&type=script&lang=js&"
import style0 from "./SubDisposition.vue?vue&type=style&index=0&id=2cbf0a73&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports